module.exports = __webpack_public_path__ + "img/a16.66ccd51f.svg";